import { FC } from 'react';
import { Rating } from '@mui/material';
import './styles.scss';

interface IProps {
  value: number;
  setValue: (arg0: number) => void;
  error?: string;
}

const RatingInput: FC<IProps> = ({ value, setValue, error }) => {
  return (
    <div className='rating'>
      <div className='filter__title'>Rating</div>
      <Rating
        className='rating__stars'
        value={value}
        onChange={(event, newValue) => setValue(newValue!)}
        precision={0.5}
      />
      {error && <span className='rating__error'>{error}</span>}
    </div>
  );
};
export default RatingInput;
